<template>
    <div class="box1">
        <div class="main">
            <div class="title">
                <div class="text">导游基本信息</div>
            </div>
            <div class="content">
                <div class="picture">
                    <img src="../../../../assets/complaint/img.jpg" alt="">
                </div>
                <div class="row first">
                    <div class="left">姓名</div>
                    <div class="right">石梅</div>
                </div>
                <div class="row">
                    <div class="left">性别</div>
                    <div class="right">女</div>
                </div>
                <div class="row">
                    <div class="left">游云南认证状态</div>
                    <div class="right">已上线</div>
                </div>
                <div class="row">
                    <div class="left">联系电话</div>
                    <div class="right">18487147923</div>
                </div>
                <div class="row">
                    <div class="left">民族</div>
                    <div class="right">蒙古族</div>
                </div>
                <div class="row">
                    <div class="left">身份证号</div>
                    <div class="right">53322219751130002X</div>
                </div>
                <div class="row">
                    <div class="left">文化程度</div>
                    <div class="right">中技</div>
                </div>
                <div class="row">
                    <div class="left">注册地</div>
                    <div class="right">丽江</div>
                </div>
                <div class="row">
                    <div class="left">导游职业注册等级</div>
                    <div class="right">初级</div>
                </div>
                <div class="row">
                    <div class="left">导游星级</div>
                    <div class="right">五星级</div>
                </div>
                <div class="row">
                    <div class="left">所属旅行社</div>
                    <div class="right">丽江中国国际旅行社</div>
                </div>
                <div class="row">
                    <div class="left">导游证号</div>
                    <div class="right">FPY74161</div>
                </div>
                <div class="row">
                    <div class="left">导游语种</div>
                    <div class="right">普通话，英语</div>
                </div>
                <div class="row">
                    <div class="left">导游人员资格证号</div>
                    <div class="right">YN990679</div>
                </div>
                <div class="row">
                    <div class="left">导游签约旅行社名称</div>
                    <div class="right">玉龙县梦里水乡空间发顺丰快旅行社有限公司</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>
<style lang="less" scoped>
    .box1 {
        width: 100%;
        padding: 14px;
        background-color: #e3e0e0;
        box-sizing: border-box;
        .main {
            width: 100%;
            padding: 14px;
            background-color: #fff;
            .title {
                width: 100%;
                padding: 5px 0;
                box-sizing: border-box;
                border-bottom: 1px solid #efeded;
                .text {
                    font-size: 16px;
                    font-weight: 500;
                    border-left: 5px solid blue;
                    padding-left: 10px;
                }
            }
            .content {
                width: 100%;
                .picture {
                    width: 70px;
                    height: 100px;
                    position: absolute;
                    top: 60px;
                    left: 50%;
                    margin-left: -35px;
                    background-color: pink;
                    img {
                        width: 100%;
                    }
                }
                .row {
                    font-size: 14px;
                    min-height: 20px;
                    margin-top: 20px;
                    display: flex;
                    .left {
                        float: left;
                        width: 40%;
                        text-align: right;
                    }
                    .right {
                        float: left;
                        width: 55%;
                        margin-left: 10px;
                    }
                }
                .first {
                    margin-top: 130px;
                }
            }
        }
    }
</style>
